<template>
    <div class="cta-card-wrapper">
        <div class="cta-card">
            <PrismicRichText :field="title" class="title" />
            <PrismicRichText :field="text" class="text" />
            <VJoyButton v-if="ctaLink" :href="ctaLink" variant="main">
                {{ ctaText }}
            </VJoyButton>
        </div>
    </div>
</template>

<script setup lang="ts">
    import type {KeyTextField, RichTextField} from '@prismicio/types';
    import {PrismicRichText} from '@prismicio/vue';
    import {VJoyButton} from '@maltjoy/core-vue';

    defineProps<{title: RichTextField; text: RichTextField; ctaLink: KeyTextField; ctaText: KeyTextField}>();
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;
    @use '~/assets/styles/variables' as *;

    .cta-card-wrapper {
        @include mq.screen_sm(min) {
            padding: var(--joy-core-spacing-4);
            border-radius: var(--joy-core-radius-4);
        }
    }

    .cta-card {
        background-color: var(--joy-color-quaternary-10);
        background-image: url('~/assets/svg/CTACardShapes.svg');
        background-position: top left;
        background-size: 100% auto;
        background-repeat: no-repeat;
        width: 100%;
        height: 100%;
        padding: var(--joy-core-spacing-9) var(--joy-core-spacing-6);
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        border-radius: var(--joy-core-radius-4);

        @media (max-width: $mobile-breakpoint) {
            padding: var(--joy-core-spacing-5) var(--joy-core-spacing-4);
        }
        .title {
            margin-bottom: var(--joy-core-spacing-5);
            max-width: 70%;
        }
        .text {
            margin-bottom: var(--joy-core-spacing-6);
            max-width: 80%;
            flex-grow: 1;
        }
        .joy-button {
            width: 100%;
            @include mq.screen_sm(min) {
                width: auto;
            }
        }
    }
</style>
